import { render, staticRenderFns } from "./IntentInfo.vue?vue&type=template&id=50992772&scoped=true"
import script from "./IntentInfo.vue?vue&type=script&lang=js"
export * from "./IntentInfo.vue?vue&type=script&lang=js"
import style0 from "./IntentInfo.vue?vue&type=style&index=0&id=50992772&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50992772",
  null
  
)

export default component.exports